import { render, staticRenderFns } from "./Controles.vue?vue&type=template&id=620b2bfe&scoped=true"
import script from "./Controles.vue?vue&type=script&lang=js"
export * from "./Controles.vue?vue&type=script&lang=js"
import style0 from "./Controles.vue?vue&type=style&index=0&id=620b2bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b2bfe",
  null
  
)

export default component.exports